"use client";
/*eslint-disable */
import React from "react";
import logo_da from "../styles/images/logo_distribuidora_blanco.svg";
import { Link } from "react-router-dom";

const FooterLayout: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="template-footer-two pt-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-footer-widget">
                <Link to={"/"} className="navbar-brand">
                  <img src={logo_da} alt="site logo" width={500} height={100} />
                </Link>
                {/*  <ul className="footer-contact-info">
                  <li>
                    <i className="bx bx-phone-call"></i>
                    <a href="tel:+1-485-456-0102">+1-485-456-0102</a>
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:hello@abev.com">hello@abev.com</a>
                  </li>
                  <li>
                    <i className="bx bx-map"></i>
                    2750 Quadra Street Victoria, Canada.
                  </li>
                </ul>
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-facebook-app-symbol"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-instagram"></i>
                    </a>
                  </li>
                </ul> */}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-footer-widget pl-3">
                <h3>Sobre nosotros</h3>
                <ul className="quick-links">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/nosotros">Nosotros</Link>
                  </li>
                  <li>
                    <Link to="/productos">Productos</Link>
                  </li>
                  <li>
                    <Link to="/contacto">Contacto</Link>
                  </li>
                  {/* <li>
                    <Link to="/contacto">Certificado de medio ambiente</Link>
                  </li>
                  <li>
                    <Link to="/contacto">Política de tratamiento de datos</Link>
                  </li> */}
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="single-footer-widget">
                <h3>Contáctanos</h3>

                <ul className="footer-contact-info">
                  <li>
                    <i className="bx bxl-whatsapp"></i>
                    <a
                      href="https://wa.me/573174318637"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +57 317 4318 637
                    </a>
                  </li>
                  <li>
                    <i className="bx bxl-whatsapp"></i>
                    <a
                      href="https://wa.me/573138170227"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +57 313 8170 227
                    </a>
                  </li>
                  <li>
                    <i className="bx bxl-whatsapp"></i>
                    <a
                      href="https://wa.me/573132085271"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      +57 313 2085 271
                    </a>
                  </li>

                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:ventas@distribuidoraaliados.com">
                      ventas@distribuidoraaliados.com
                    </a>
                  </li>
                  <br />
                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:compras@distribuidoraaliados.com">
                      compras@distribuidoraaliados.com
                    </a>
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:contabilidad@distribuidoraaliados.com">
                      contabilidad@distribuidoraaliados.com
                    </a>
                  </li>
                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:logistica@distribuidoraaliados.com">
                      logistica@distribuidoraaliados.com
                    </a>
                  </li>
                  <li>
                    <i className="bx bx-map"></i>
                    <strong>Sede Álamos :</strong> <br /> Transversal 93 No
                    53-32 Parque empresarial el Dorado.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/*  <div className="copyright-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-7">
                <p>
                  Copyright &copy; {currentYear} Abev. All Rights Reserved by{" "}
                  <a
                    href="https://envytheme.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    EnvyTheme
                  </a>
                </p>
              </div>

              <div className="col-lg-6 col-md-5">
                <ul className="social-links">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-facebook-app-symbol"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.twitter.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="flaticon-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default FooterLayout;
